// src/admin/components/DetailDrawer.jsx
import React from 'react';
import { Drawer, Box, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function DetailDrawer({ open, title, onClose, children, width = 420 }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width, p: 3 }} role="presentation">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose} aria-label="Chiudi"><CloseIcon /></IconButton>
        </Box>
        <Divider sx={{ my: 2 }} />
        {children}
      </Box>
    </Drawer>
  );
}
